let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7ylp3"), load("kIPUL"), load("7YoSv")]).then(() => parcelRequire('3MgcY'));